import { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { usePermissions } from '@/app/hooks/usePermissions';
import { prepareCarForm } from '@/modules/car/actions/async/prepare-car-form';
import { reloadFormForCurrentCar } from '@/modules/car/actions/async/reload-form-for-current-car';
import { AppDispatch } from '@/root-store';
import { scrollUp } from '@/shared/actions/scrollUp';
import { StepLayout } from '@/shared/view/StepLayout';
import { UploadCar } from '@/shared/view/Upload';

import { BaseVehicleForm } from './BaseForm';

interface IProps {
  onNavigateBack: (uri: string) => void;
  onNavigate: (path: string, replace?: boolean) => void;
}

const CreateVehicle = ({ onNavigateBack, onNavigate }: IProps) => {
  usePermissions('createCars');

  const dispatch = useDispatch() as AppDispatch;

  useEffect(() => {
    dispatch(prepareCarForm({}));
    dispatch(scrollUp());
  }, [dispatch]);

  const intl = useIntl();

  const [isUploading, setIsUploading] = useState(false);

  const handleFinishSubmit = useCallback(
    (id: string) => onNavigate(`/vehicles/${id}#docs`, true),
    [onNavigate],
  );
  const handleGoBack = useCallback(() => onNavigateBack('/todo'), [onNavigateBack]);
  const handleOpenUpload = useCallback(() => setIsUploading(true), [setIsUploading]);
  const handleUploaded = useCallback(() => dispatch(reloadFormForCurrentCar({})), [dispatch]);
  const handleFinishUpload = useCallback(() => {
    setIsUploading(false);
  }, []);
  const handleSkipUpload = useCallback(() => {
    setIsUploading(false);
  }, []);

  return (
    <>
      <StepLayout
        onClickBack={handleGoBack}
        hideProgress={true}
        title={intl.formatMessage({
          defaultMessage: 'Vehicle info',
          id: 'c0G8wG',
          description: 'Vehicle info (onboarding step title)',
        })}
      >
        <BaseVehicleForm
          onSkipSubmit={handleGoBack}
          onFinishSubmit={handleFinishSubmit}
          onOpenUpload={handleOpenUpload}
          textSubmitButton={intl.formatMessage({
            defaultMessage: 'Save',
            id: 'RT8KNi',
            description: 'Save button text',
          })}
          pageNameForEvent="to do screen"
        />
      </StepLayout>
      {isUploading && (
        <UploadCar
          onClickSkip={handleSkipUpload}
          onUploaded={handleUploaded}
          onFinishUpload={handleFinishUpload}
        />
      )}
    </>
  );
};

export { CreateVehicle };
